import { Button } from "@src/ui/button";
import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenu,
  DropdownMenuCheckboxItem,
} from "@src/ui/dropdown-menu";
import ChevronDownIcon from "@src/ui/icons/12px/chevron-down";
import useVersionQueryParams from "@src/components/libraryItemDetailPages/hooks/useVersionQueryParams";
import { trainingResourceVersionAtom } from "./atoms";
import { useAtomValue } from "jotai";

const TrainingResourceVersionHistoryDropdown: React.FC = () => {
  const { version, setVersion } = useVersionQueryParams();
  const trainingResourceVersion = useAtomValue(trainingResourceVersionAtom);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          Version: {version === "published" ? "Published" : "Draft"}{" "}
          <ChevronDownIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuCheckboxItem
          checked={version === "draft"}
          onCheckedChange={() => setVersion("draft")}
        >
          Draft
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          disabled={
            !trainingResourceVersion?.trainingResource?.publishedVersion
          }
          checked={version === "published"}
          onCheckedChange={() => setVersion("published")}
        >
          Published
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TrainingResourceVersionHistoryDropdown;
